import { useLocation } from 'react-router-dom';
import CustomIconButton from '@ui-components/IconButton/CustomIconButton';
import { useNavigate } from 'react-router';

//Icon
import BackIcon from '@assets/images/BackIcon.svg';

const PageTitle = () => {
  // Define page titles based on route paths
  const getPageTitle = () => {
    const navigate = useNavigate();
    const location = useLocation();
    switch (location.pathname) {
      case '/provider/consults':
        return 'Consult Requests';
      case '/provider/details':
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <CustomIconButton
              id="back-button"
              icon={<BackIcon />}
              onClick={() => {
                if (location.state?.prevCaseId) {
                  navigate('/provider/details', {
                    state: {
                      consultId: location.state.prevCaseId,
                      assignedFlag: location.state.assignedFlag,
                      cameFromBack: true,
                    },
                    replace: true,
                  });
                } else {
                  navigate('/provider/consults', { replace: true });
                }
              }}
            />
            <span>Back</span>
          </div>
        );
      case '/provider/metrics':
        return 'Facility Metrics';
      case '/settings':
        return 'Settings';
      default:
        return 'Default Title'; // Fallback title
    }
  };

  return getPageTitle();
};

export default PageTitle;
